import { render, staticRenderFns } from "./TemplateDesignSidebar.vue?vue&type=template&id=be5b31be&scoped=true&"
import script from "./TemplateDesignSidebar.vue?vue&type=script&lang=ts&"
export * from "./TemplateDesignSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateDesignSidebar.vue?vue&type=style&index=0&id=be5b31be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5b31be",
  null
  
)

export default component.exports